import styled from 'styled-components';

export const UserChar = styled.div`
  font-family: 'Poppins-Medium' Arial, Helvetica, sans-serif;
  text-transform: uppercase;
  display: inline-block;
  background-color: #707070;
  color: #FFFFFF;
  min-width: 33px;
  height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: relative;

  &:after {
    content: '';
    width: 31px;
    height: 31px;
    padding: 13px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    border-radius: 50%;
    background-color: transparent;
    border: 1px solid #FFFFFF;
  }

  span {
    display: inline-block;
    padding: 5px;
    font-size: 20px;
    vertical-align: middle;
    text-transform: uppercase;
  }
`;
